// Import DC and dependencies

d3 = require("d3");
crossfilter = require("crossfilter");
module.exports = require("./dc");



//////////////////
// WEBPACK FOOTER
// ./~/dc/index.js
// module id = 141
// module chunks = 0